import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../../components/primitives/Panel';
import { browseMessages as messages, browseStateMessages } from '../browseMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseRows.module.scss';
/* eslint-enable css-modules/no-unused-class */

const ROWS = [0, 1, 2];

/** Skeleton rows in two panels (design b3): the first search of a deep link, before any answer. */
const BrowseSkeletonComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.sectionStack} aria-busy="true" aria-label={intl.formatMessage(browseStateMessages.loading)}>
      {[messages.typeArtists, messages.typeTracks].map((title) => (
        <Panel as="section" key={title.id}>
          <PanelHead title={intl.formatMessage(title)} />
          <PanelBody flush>
            {ROWS.map((row) => (
              <div key={row} className={clsx(styles.resultRow, styles.skeletonRow)}>
                <span className={clsx(styles.skeleton, styles.skeletonCover)} />
                <span>
                  <span className={clsx(styles.skeleton, styles.skeletonName)} />
                </span>
                <span className={styles.skeleton} />
                <span className={styles.skeleton} />
              </div>
            ))}
          </PanelBody>
        </Panel>
      ))}
    </div>
  );
};

export const BrowseSkeleton = TypedMemo(BrowseSkeletonComponent);
